import { useEffect } from "react"
import { useParams } from "react-router-dom"
import useRedirectPageReset from "./useRedirectPageReset"
import Loading from "../../components/loading/Loading"

const RedirectPageReset = () => {
    const {
        checkTokenAutoLogin
    } = useRedirectPageReset()
    const params = useParams()

    useEffect(() => {
        if (params.token) {
            checkTokenAutoLogin(params.token)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <div className="container-fluid d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
            <div className="text-center">
                <Loading state={true} />
                <h3 className="mt-4" style={{ color: '#02B4CC' }}>Authenticating...</h3>
                <p style={{ color: '#6c757d' }}>Please wait while we redirect you.</p>
            </div>
        </div>
    )
}

export default RedirectPageReset